import {createContext, ReactNode, useState} from 'react';
import {AlertState, AlertType} from "./alert.ts";

const ALERT_TIME = 15000;

const initialState: AlertState = {
    text: '',
    type: AlertType.success,
    setAlert: () => {}
};

const AlertContext = createContext<AlertState>(initialState);

export const AlertProvider = ({children}: { children: ReactNode }) => {
    const [text, setText] = useState('');
    const [type, setType] = useState(AlertType.success);

    const setAlert = (type: AlertType, text: string) => {
        setType(type);
        setText(text);

        setTimeout(() => {
            setType(AlertType.success);
            setText('');
        }, ALERT_TIME);
    };

    return (
        <AlertContext.Provider
            value={{
                text,
                type,
                setAlert,
            }}
        >
            {children}
        </AlertContext.Provider>
    );
};

export default AlertContext;
